import { ANumber } from './anumber';
export interface IANumberAssignment {
    aNumberId?: string | null;
    aNumber?: any;
    contentProviderUuid?: string | null;
    programContentUuid?: string | null;
    createDate?: string | null;
    updateDate?: string | null;
}

export class ANumberAssignment {
    public aNumberId?: string | null;
    public aNumber?: any;
    public contentProviderUuid?: string | null;
    public programContentUuid?: string | null;
    public createDate?: string | null;
    public updateDate?: string | null;

    constructor(aNumberAssignment: IANumberAssignment) {
        if (!aNumberAssignment) {
            throw new Error("Cannot construct ANumber Assignment from falsey IANumberAssignment");
        }
    }

    public static empty(): ANumberAssignment {
        return new ANumberAssignment({});
    }

    // public toNewANumberAssignmentDto(): IANumberAssignment {
    //     return {
    //         aNumber: this.aNumber,
    //         contentProviderUuid: this.contentProviderUuid,
    //         programContentUuid: this.programContentUuid,
    //         createDate: this.createDate,
    //         updateDate: this.updateDate
    //     };
    // }

    public toNewANumberAssignmentDto(): IANumberAssignment {
        return {
            aNumber: this.aNumber,
            contentProviderUuid: this.contentProviderUuid
        };
    }
}
